// Copyright (c) 2025 Audere, All Rights Reserved

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { createStyleSheet } from "../utils/styles";
import type { GenerateSDkDialogProps } from "../types/projects";

const GenerateSDkDialog = (props: GenerateSDkDialogProps) => {
  const { open, onClose } = props;
  const { t } = useTranslation("GenerateSDkDialog");
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent sx={styles.dialogContent}>
        <DialogTitle sx={styles.dialogTitle}>{t("generateSDKTitle")}</DialogTitle>
        <Typography variant="body2" sx={styles.dialogDescription}>
          {t("generateSDKDescription")}
        </Typography>
        <DialogActions sx={styles.dialogActions}>
          <Button onClick={onClose} variant="contained" color="primary">
            {t("common:close")}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateSDkDialog;

const styles = createStyleSheet({
  dialogTitle: {
    p: 0,
    mb: 2,
  },
  dialogDescription: {
    mb: 2,
  },
  dialogContent: {
    p: 2,
  },
  dialogActions: { p: 0, mt: 3 },
});
